import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import RepeatIcon from '@material-ui/icons/Repeat';
import { handleSnackBar} from '../../../store/global/actions';
import { getRightDrawerStatus } from '../../../store/global/selectors';


const useStyles = makeStyles((theme) => ({
    backgroundStyle: {
        display: "flex",
        flexDirection: "row",
        position: "fixed",
        bottom: 10,
        right: 10,
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
    },

    root: {
        transform: 'translateZ(0px)',
        flexGrow: 1,
    },
    exampleWrapper: {
        position: 'relative',
        marginTop: theme.spacing(3),
        height: 380,
    },
    radioGroup: {
        margin: theme.spacing(1, 0),
    },
    speedDial: {
        zIndex: 999,
        position: 'absolute',
        '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
            bottom: theme.spacing(2),
            right: theme.spacing(2),
        },
        '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
            top: theme.spacing(2),
            left: theme.spacing(2),
        },
    },
}));

export default function SimulationSpeedDial({ onStart }) {

    const dispatch = useDispatch();
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const [hidden, setHidden] = React.useState(false);
    const [direction, setDirection] = React.useState('up');
    const rightDrawerStatus = useSelector(getRightDrawerStatus);


    const handleClick = () => {

    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const actions = [
        { icon: <RepeatIcon onClick={handleClick} />, name: 'Add transaction', type: 'eventPayolad' },
        // { icon: <RepeatIcon onClick={handleClick} />, name: 'Add transaction', type: 'simulationTransaction' }
    ];

    const onActionClick = (type) => {
        dispatch(handleSnackBar({open:true, message: 'Start drawing the transaction', seviority:'info'}))
        onStart()    
    }



    return (



        <div className={classes.backgroundStyle}>
            <div className={classes.root}>

                <div>


                    <SpeedDial
                        ariaLabel="Actions"
                        className={classes.speedDial}
                        hidden={hidden}
                        icon={<SpeedDialIcon data-ui-tour-id="sim-speed-dial"/>}
                        onClose={handleClose}
                        onOpen={handleOpen}
                        open={open}
                        direction={direction}
                    >
                        {actions.map((action) => (
                            <SpeedDialAction
                                key={action.name}
                                icon={action.icon}
                                //   disabled={transactions.length <= 1 && action.type === 'reusedTransaction' ? true : false}
                                tooltipTitle={action.name}
                                onClick={e => { handleClose(); onActionClick(action.type) }}
                            />
                        ))}
                    </SpeedDial>
                </div>
            </div>
        </div>
    );
}